import HomePage from '../components/Home';
import SchedulePage from '../components/Schedule';
import SignUpPage from '../components/SignUp';
import SignInPage from '../components/SignIn';
import PasswordForgetPage from '../components/PasswordForget';
import AccountPage from '../components/Account';
import AdminPage from '../components/Admin';
import NeedValidationPage from "../components/NeedValidation";
import FlightPage from "../components/Flights";
import {ROLES} from "./index";
import TripBoard from "../components/TripBoard";
import TripPage from "../components/Trips";
import SettingsPage from "../components/Settings";
import StatisticsPage from "../components/Statistics";
import MonthlyPlanPage from "../components/MonthlyPlan";
import {Home, Event, LocationCity, Person, Settings, SupervisorAccount, Assessment, DateRange} from "@material-ui/icons";

export const ROUTES = {
    HOME: {
        path: "/home",
        name: "Home",
        icon: Home,
        component: HomePage,
    },
    TRIP_BOARD: {
        path: "/trips",
        name: "Trip Board",
        icon: LocationCity,
        component: TripBoard,
    },
    PLAN: {
        name: "Plan",
        path: "/plan",
        icon: DateRange,
        component: MonthlyPlanPage,
        role: ROLES.SCHEDULER,
        noFrame: true,
    },
    SCHEDULE: {
        name: "Schedule",
        path: "/schedule",
        icon: Event,
        component: SchedulePage,
        noFrame: true,
    },
    STATISTICS: {
        name: "Statistics",
        path: "/statistics",
        icon: Assessment,
        component: StatisticsPage,
        role: ROLES.SCHEDULER,
    },
    ACCOUNT: {
        name: "Account",
        path: "/account",
        icon: Person,
        component: AccountPage,
    },
    ADMIN: {
        name: "Admin",
        path: "/admin",
        icon: SupervisorAccount,
        component: AdminPage,
        role: ROLES.ADMIN,
    },
    SETTINGS: {
        name: "Settings",
        path: "/settings",
        icon: Settings,
        component: SettingsPage,
        role: ROLES.ADMIN,
    },
    SIGN_IN: {
        path: "/signin",
        component: SignInPage
    },
    SIGN_UP: {
        path: "/signup",
        component: SignUpPage
    },
    PW_FORGET: {
        path: "/pw-forget",
        component: PasswordForgetPage
    },
    NEED_VALIDATION: {
        path: "/need-validation",
        component: NeedValidationPage
    },
    FLIGHT: {
        path: "/flight/:flightId",
        component: FlightPage
    },
    TRIP: {
        path: "/trip/:tripId",
        component: TripPage,
    }
}
